import React, { Component } from "react";
import {getFavoriteTopics,removeFavoriteTopics,addFavoriteTopics} from '../config/Variables';
export default class FollowSection extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      textlabel:'تابع',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null,
      isList:false,
    }
    this.handleInputChange = this.handleInputChange.bind(this);


    if (localStorage.getItem('user-info')) {

    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getFavoriteTopics, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        data.data.map(({ tid }, index2) => {
          this.state.numberstid.push(tid);
          //this.setState({ numberstid: [this.state.numberstid, tid] })
          this.setState({ numberstid: this.state.numberstid })
          this.state.hobbies.push(tid);
        });
      });
  }
}
  async   handleInputChange(event) {

    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
    var tid = document.getElementById('section_id').getAttribute('data-value');
    const isList=false;

    let item = { tid,isList };
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
         

         
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          var selectedId1='tag-'+tid; 
          document.getElementById(selectedId1).innerHTML = "<i class='icomoon-icon icon-plus-green'></i> متابع";
          this.props.samirCallback("success");
          
        }
      }
    }
  }else{
    var tid = document.getElementById('section_id').getAttribute('data-value');


    let item = { tid };
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(removeFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          var selectedId='tag-'+tid; 
          document.getElementById(selectedId).innerHTML = "<i class='icomoon-icon icon-plus-green'></i> تابع";
          this.props.samirCallback("success");
        }
      }
    }




  }
  }

  render() {
    const {
      users,
      error,
      numberstid
    } = this.state;
      if (localStorage.getItem('user-info')) {
    var tid = document.getElementById('section_id').getAttribute('data-value');
    const fruitss = this.state.numberstid;
    const ttt = parseInt(tid);
    const ss = fruitss.includes(ttt); //true
    
    if (ss) {
    return (
      <>
          <label for="follow-tag" class="follow-tag">
          <input type="checkbox" id="follow-tag" name="tag" defaultChecked={true} onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} class="form-check"/>
          <div  id={`tag-${tid}`} class="button small rounded follow-check"><i class="icomoon-icon icon-plus-green"></i> متابع</div>
      </label> 
      </>

    );
  }else{
    return (
       <>
       <label for="follow-tag" class="follow-tag">
       <input type="checkbox" id="follow-tag" name="tag"  onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} class="form-check"/>
       <div  id={`tag-${tid}`} class="button small rounded follow-check"> <i class="icomoon-icon icon-plus-green"></i> تابع</div>
   </label> 
   </>
    );
    }
  }else{
    return (
      <>
      <label for="follow-tag" class="follow-tag">
      <input type="checkbox" id="follow-tag" name="tag" class="form-check modal-toggle" data-id="modal-notification"/>
      <div  id={`tag-${tid}`} class="button small rounded follow-check"> <i class="icomoon-icon icon-plus-green"></i> تابع</div>
   </label> 
  </>
    );
  }
}
}
